import React from "react";

import { Redirect } from "react-router-dom";

const Unauthorized: React.FC = () => {
  return <Redirect to="/login" />;
};

export default Unauthorized;
